import { useScopedTranslate } from '@locale/translate';

export const translations = {
  en: {
    no_options: 'No more options',
    placeholder: 'Select...',
  },
  is: {
    no_options: 'Ekki fleiri valmöguleikar',
    placeholder: 'Velja...',
  },
  dk: {
    no_options: 'Ikke flere muligheder',
    placeholder: 'Vælg...',
  },
};

export const useSelectTranslations = () => useScopedTranslate(translations);
